import { Link, useNavigate } from "react-router-dom";
import Footer from "../../layout/Footer";
import { decryptToken, encryptAndStoreLoc } from "../../helper/localStore";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../../layout/Header";
import { useTranslation } from "react-i18next";
import "../../i18n";

const AIDashboard = () => {
    const { t } = useTranslation("AIDashboard");
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [userData, setUserData] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        if (token) {
            try {
                const decodedToken = decodeURIComponent(token);
                const tokens = decodedToken.replace(/ /g, "+");
                const obj = decryptToken(tokens);
                const newObj = JSON.parse(obj.replaceAll("'", '"'));
                setUserData(newObj);
                encryptAndStoreLoc("AIUserData", newObj);
            } catch (error) {
                navigate("/sign-in");
            }
        } else {
            navigate("/sign-in");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <>
            <Header />
            <section className="courses-dashboard">
                <div className="container">
                    <h4>
                        {t("welcome")} {userData?.name}!
                    </h4>

                    <h5>{t("courses")}</h5>

                    <div className="row">
                        <div className="col-4">
                            <div className="card">
                                <div className="learning-courses-images">
                                    <img
                                        src="/png/ai-learning.png"
                                        className="w-100 h-100"
                                        alt=""
                                    />
                                </div>
                                <div className="card-body">
                                    <span>{t("marketingandssales")}</span>
                                    <h6>t{"ailearning"}</h6>
                                    <Link
                                        to="/free-trail/overview-step"
                                        state={{
                                            userData,
                                        }}
                                    >
                                        {t("startcourse")}{" "}
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="22"
                                            height="14"
                                            viewBox="0 0 22 14"
                                            fill="none"
                                        >
                                            <path
                                                d="M1 6.99854H21L16 1"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            ></path>
                                            <path
                                                d="M21 6.99854L16 13"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                stroke-linecap="round"
                                            ></path>
                                        </svg>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default AIDashboard;
